export const CHALLENGE_SESSION_STORAGE_KEYS = Object.freeze({
  SESSION: 'COGNITO_CHALLENGE_SESSION',
  USERNAME: 'COGNITO_CHALLENGE_USERNAME',
  CHALLENGE_NAME: 'COGNITO_CHALLENGE_NAME',
});
